<template>

  <b-card
    :title="title"
  >
    <h6 class="card-subtitle text-muted mb-2">
      {{dailyStatus.forDateToString}} -
      {{(dailyStatus.isMorning ? 'Matin' : 'Soir')}} -
      <strong v-if="!dailyStatus.publicationDate" class="main-red-color">Non publié</strong>
      <span v-else>Publié</span>
    </h6>

    <b-row>
      <b-col class="card-section pt-2 pb-2 mb-1">
        <div class="mb-0 main-color card-title">
          <strong>Objectifs de la journée</strong>
        </div>
        <div class="multiline mt-0" v-if="dailyStatus.dailyGoalInformation">
          {{ dailyStatus.dailyGoalInformation }}
        </div>
      </b-col>
      <b-col class="card-section pt-2 pb-2 mb-1">
        <div class="mb-2 main-color card-title">
          <strong>Transit</strong>
        </div>
        <div v-if="dailyTransits.length > 0">
          <template v-for="(dailyTransit, index) in dailyTransits">{{index > 0 ? ', ':''}}{{dailyTransit.transit.name}}</template>
        </div>
        <div class="multiline" v-if="dailyStatus.transitInformation">
          {{ dailyStatus.transitInformation }}
        </div>
        <div v-if="dailyTransits.length === 0 && !dailyStatus.transitInformation">
          N/A
        </div>
      </b-col>
      <b-col class="card-section pt-2 pb-2 mr-3">
        <div class="mb-2 main-color card-title">
          <strong>Alimentation</strong>
        </div>
        <strong>{{ 'Alimentation assistée : ' + (dailyStatus.tubeFeeding ? 'Oui' : 'Non') }}</strong>
        <div v-if="dailyFoods.length > 0">
          <div v-for="dailyFood in dailyFoods">
            <strong>{{dailyFood.food.name}} - {{dailyFood.eatenPercentage}}%</strong>
          </div>
        </div>
        <div class="multiline" v-if="dailyStatus.foodInformation">
          {{ dailyStatus.foodInformation }}
        </div>
        <div v-if="dailyFoods.length === 0 && !dailyStatus.foodInformation">
          N/A
        </div>
      </b-col>

    </b-row>
    <b-row class="mt-2 pt-2">
      <b-col class="card-section p-2 mr-3">
        <div class="mb-2 main-color card-title">
          <strong>Etat de santé</strong>
        </div>
        <b-row class="ml-2">
          <b-col>
            <b-row>
              <img class="health-state-img mr-4" :src="healthStatesImagesBaseUrl+dailyStatus.healthState.imageName" alt="Image associée à l'état">
              <b-col>
                <b-row>
                  L'état de {{dailyStatus.hospitalization.animal.name}} est
                </b-row>
                <b-row class="black-bold">
                  {{dailyStatus.healthState.name}}
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row class="black-bold">
              Température :
            </b-row>
            <b-row>
              {{ dailyStatus.temperature ? dailyStatus.temperature + "°C" : "Non renseigné"}}
            </b-row>
          </b-col>
          <b-col>
            <b-row class="black-bold">
              Hydratation :
            </b-row>
            <b-row>
              {{ dailyStatus.hydration ? dailyStatus.hydration:'Aucune réhydratation' }}
            </b-row>
          </b-col>
          <b-col>
            <b-row class="black-bold">
              Poids :
            </b-row>
            <b-row>
              {{ dailyStatus.weight ? dailyStatus.weight: "Non renseigné"}}
            </b-row>
          </b-col>
        </b-row>
        <div class="multiline ml-1" v-if="dailyStatus.healthStateInformation">
          {{ dailyStatus.healthStateInformation }}
        </div>

      </b-col>
    </b-row>
  </b-card>

</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/BackArrow";
import ShowActions from "../../components/ShowActions";
import DailyStatusDeleteModal from "./DailyStatusDeleteModal";

export default {

  name: 'DailyStatusShowCard',

  components: {
    BackArrow,
    ShowActions,
    DailyStatusDeleteModal
  },

  props: {
    title: {
      type: String,
      required: true
    },
    dailyStatus: {
      type: Object,
      required: true
    }
  },

  data(){
    return {
      dailyTransits: [],
      dailyFoods: []
    }
  },

  computed: {
    healthStatesImagesBaseUrl() {
      return process.env.SERVER_URL + '/assets/healthStates/'
    }
  },

  mounted() {
    this.fetchDailyTransits()
    this.fetchDailyFoods()
  },

  methods: {

    fetchDailyTransits() {
      api
        .get(`/dailyStatus/getDailyTransitsForDailyStatus?dailyStatusId=${this.dailyStatus.id}`)
        .then(response => {
          this.dailyTransits = response.data
        })
    },

    fetchDailyFoods() {
      api
        .get(`/dailyStatus/getDailyFoodsForDailyStatus?dailyStatusId=${this.dailyStatus.id}`)
        .then(response => {
          this.dailyFoods = response.data
        })
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'DailyStatusEdit',
        params: {
          dailyStatusId: this.dailyStatus.id
        }
      })
    },

    clickOnDeleteBtn() {
      this.$bvModal.show('daily-status-delete-modal')
    },

    didDeleteDailyStatus() {
      this.$router.push({
        name: 'DailyStatusIndex'
      }, () => {
        this.$nextTick(() => {
          this.successToast(`État quotidien supprimé`)
        })
      })
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }

  }
}
</script>

<style scoped>
.health-state-img {
  width: 60px;
}
.card-section {
  border : 1px solid var(--neutral-300);
  border-radius: 10px;
  margin-left: 1.20rem;
}
.black-bold{
  font-weight: bolder;
  font-size: medium;
}
</style>



// WEBPACK FOOTER //
// src/views/dailyStatus/DailyStatusShowCard.vue